var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusGray300(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8317H4.99996C4.77895 10.8317 4.56698 10.7439 4.4107 10.5876C4.25442 10.4313 4.16663 10.2194 4.16663 9.99837C4.16663 9.77736 4.25442 9.5654 4.4107 9.40912C4.56698 9.25284 4.77895 9.16504 4.99996 9.16504H15C15.221 9.16504 15.4329 9.25284 15.5892 9.40912C15.7455 9.5654 15.8333 9.77736 15.8333 9.99837C15.8333 10.2194 15.7455 10.4313 15.5892 10.5876C15.4329 10.7439 15.221 10.8317 15 10.8317Z",
    fill: "#DCDCDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusGray300);
export default __webpack_public_path__ + "static/media/minus_gray300.a5161ba33235409972bae72a01e3f011.svg";
export { ForwardRef as ReactComponent };